import React from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import DateSelectorDays from '../../../pages/components/DateInputDays'
import { SelectGlobal } from '../../../pages/components/SelectGlobal'
import listLayoutStyles from '../../../pages/components/ListTableLayout/listTableLayout.module.css'
import toolbarStyles from '../OrderServiceToolbar/orderServiceToolbar.module.css'

const REQUEST_STATUS_OPTIONS = [
  { name: 'PENDENTE', value: 'PENDENTE', linkIcon: '/media/icons/duotune/general/gen013.svg', iconColor: 'info' },
  { name: 'ATENDIDO', value: 'ATENDIDO', linkIcon: '/media/icons/duotune/general/gen043.svg', iconColor: 'success' },
  { name: 'CANCELADO', value: 'CANCELADO', linkIcon: '/media/icons/duotune/general/gen040.svg', iconColor: 'danger' },
]

type Props = {
  search: React.ReactNode
  filterStatus: string
  setFilterStatus: (value: string) => void
  filterDateInit: string
  setFilterDateInit: (value: string) => void
  filterDateEnd: string
  setFilterDateEnd: (value: string) => void
  filterClient: string
  setFilterClient: (value: string) => void
  clients: any[]
  showClientFilter: boolean
}

export function RequestServiceToolbar({
  search,
  filterStatus,
  setFilterStatus,
  filterDateInit,
  setFilterDateInit,
  filterDateEnd,
  setFilterDateEnd,
  filterClient,
  setFilterClient,
  clients,
  showClientFilter,
}: Props) {
  const activeFiltersCount = [filterStatus, filterDateInit, filterDateEnd, showClientFilter ? filterClient : '']
    .filter((value) => value !== '' && value !== null && value !== undefined).length

  const clearFilters = () => {
    setFilterStatus('')
    setFilterDateInit('')
    setFilterDateEnd('')
    setFilterClient('')
  }

  return (
    <div className={toolbarStyles.toolbarWrap}>
      <div className={`${listLayoutStyles.listToolbar} ${listLayoutStyles.listToolbarPanel}`}>
        <div className={listLayoutStyles.listToolbarFilters}>
          <div className={toolbarStyles.searchBox}>{search}</div>

          <div className='dropdown'>
            <button
              type='button'
              className='btn btn-lg btn-light btn-active-color-primary btn-sm dropdown-toggle position-relative'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              data-bs-auto-close='outside'
              title='Filtros'
            >
              <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3' />
              {activeFiltersCount > 0 && (
                <span className='position-absolute top-0 start-100 translate-middle badge badge-circle badge-primary'>
                  {activeFiltersCount}
                </span>
              )}
            </button>

            <div className={`dropdown-menu dropdown-menu-end p-4 ${listLayoutStyles.listFilterDropdownMenu} ${toolbarStyles.filterMenu}`}>
              <label className='form-label fw-bold' style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}>Outros Filtros</label>
              <div className='separator my-2'></div>

              <div style={{marginTop: '0.5rem', marginBottom: '1rem', width: '100%'}}>
                <SelectGlobal
                  itens={REQUEST_STATUS_OPTIONS}
                  buttonAll={true}
                  textSearch={'Buscar status'}
                  textButtonInit={'Filtrar por STATUS'}
                  labelKey='name'
                  valueKey='value'
                  typeIcon='svg'
                  linkIcon='/media/icons/duotune/general/gen025.svg'
                  sizeIconSvg='2'
                  value={filterStatus}
                  style={{width: '100%'}}
                  onChange={(value: string) => setFilterStatus(value)}
                />

                {showClientFilter && (
                  <SelectGlobal
                    itens={Array.isArray(clients) ? clients : []}
                    buttonAll={true}
                    textSearch={'Buscar cliente'}
                    textButtonInit={'Filtrar por CLIENTE'}
                    labelKey='nameResponsible'
                    valueKey='id'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/communication/com006.svg'
                    sizeIconSvg='2'
                    value={filterClient}
                    className='mt-1'
                    style={{width: '100%'}}
                    onChange={(value: string) => setFilterClient(value)}
                  />
                )}

                <div className='separator my-3'></div>
                <label className='form-label fw-bold mb-2'>Filtrar por PERÍODO</label>

                <div className={listLayoutStyles.listFilterDates}>
                  <div>
                    <label className='form-label fw-semibold fs-7 mb-1 text-gray-500'>De</label>
                    <DateSelectorDays
                      selectedDate={filterDateInit !== '' ? new Date(filterDateInit) : new Date()}
                      setSelectedDate={(date: any) => setFilterDateInit(date.toString())}
                    />
                  </div>
                  <div>
                    <label className='form-label fw-semibold fs-7 mb-1 text-gray-500'>Até</label>
                    <DateSelectorDays
                      selectedDate={filterDateEnd !== '' ? new Date(filterDateEnd) : new Date()}
                      setSelectedDate={(date: any) => setFilterDateEnd(date.toString())}
                    />
                  </div>
                </div>
              </div>

              <div className='separator my-2'></div>

              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button
                  type='button'
                  className='btn btn-color-gray-600 btn-active-color-primary'
                  onClick={clearFilters}
                >
                  Limpar todos os filtros <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
